import { render } from "./VideoRowEditModal.vue?vue&type=template&id=5d5c1db4&scoped=true"
import script from "./VideoRowEditModal.vue?vue&type=script&lang=js"
export * from "./VideoRowEditModal.vue?vue&type=script&lang=js"

import "./VideoRowEditModal.vue?vue&type=style&index=0&id=5d5c1db4&scoped=true&lang=less"
import "./VideoRowEditModal.vue?vue&type=style&index=1&id=5d5c1db4&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d5c1db4"]])

export default __exports__